export default __webpack_public_path__ + "static/media/delegates__cards-list-item-icon-3.9fdd873c.svg";